import '@angular/localize/init';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './app/environments/environment';
import { appConfig } from './app/app.config';


export function getBaseUrl() {
	return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
	.catch(err => console.error(err));
